import { render, staticRenderFns } from "./tabBoatLicense.vue?vue&type=template&id=d5155500&"
import script from "./tabBoatLicense.vue?vue&type=script&lang=js&"
export * from "./tabBoatLicense.vue?vue&type=script&lang=js&"
import style0 from "./tabBoatLicense.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports